import React from 'react';
import './Member.css';

function Member() {
  return (
    <div className="container-fluid member-section">
      <div className="row member-sec-wrap">
        <div className="col-lg-6 col-md-12">
          <img src="/assets/images/employer-chart.png" alt="For Employers" className="img-fluid" />
         <a href="/signup"><button className="green-btn-mob">Find My Next Employee  <img src="/assets/images/arrow-up-left-black.svg" alt=""/> </button></a> 
        </div>
        <div className="col-lg-6 col-md-12  right-content-wrap">
        <button className="pink-btn">For Employers</button>
          <div className='title'>Join MPLOI to Discover Your Perfect <span>Team Member!</span> </div>
          <div className='description'>
            Revolutionise Your Hiring Experience with MPLOI's AI-Powered Matchmaking. Say Hello to
            Effortless Recruitment and Goodbye to Tedious Searches.
          </div>
         <a href="/signup"> <button className="green-btn">Find My Next Employee  <img src="/assets/images/arrow-up-left-black.svg" alt=""/> </button></a>
        </div>
      </div>
      
      <div className="row ">
        <div className="col-lg-6 col-md-12 ">
          <div className='left-content-wrap'>
          <button className="blue-btn">For Employees </button>
          <div className='title'>Join MPLOI to Find Your Dream Job!</div>
          <div className='description'>
                Transform Your Job Search with MPLOI's AI-Powered Matching. Say Hello to Seamless
                Opportunities and Goodbye to Endless Scrolling. Join Today and Find Your Perfect Fit!
            </div>
           <a href="/signup"> <button className="green-btn">Find My Next Role  <img src="/assets/images/arrow-up-left-black.svg" alt=""/> </button></a>
          </div>
           
        </div>
        <div className="col-lg-6 col-md-12">
          <img src="/assets/images/employ-chart.png" alt="For Employees" className="img-fluid" />
          <a href="/signup"><button className="green-btn-mob">Find My Next Role  <img src="/assets/images/arrow-up-left-black.svg" alt=""/> </button></a>
        </div>
      </div>
    </div>
  );
}

export default Member;
